<template>
    <div>
        <div id="car_body" class="mt10" v-if="this.list.length">
            <div class="car_head over" style="text-align:center">
                <div class="left b7">
                    <input type="checkbox" v-model="checkAll" style="margin-right:10px;">全选({{checkedCount}})
                </div>
                <p class="left b38">商品</p>
                <p class="left b14">单价</p>
                <p class="left b14">数量</p>
                <p class="left b14">小计</p>
                <p class="left b9">操作</p>
            </div>
            <div class="ov" id="goods_on">
                <div class="carzu">
                    <dl class="car" v-for="(item,index) in list" :key="index" :data-id="item.id" style="text-align:center;">
                        <dt class="b7">
                            <input type="checkbox" :value="item.id" v-model="checked" @click="currClick(item,index)">
                        </dt>
                        <dd class="b38">
                            <div>
                                <router-link :to="{path:'/detail', query:{id:item.pro.id}}"  target="_blank" style="float:left; margin-right:10px;">
                                    <img :src="item.pro.piclink" class="ca_pic">
                                </router-link>
                            </div>
                            <div>
                                <router-link :to="{path:'/detail', query:{id:item.pro.id}}"  target="_blank" class="gk_a">
                                    {{item.pro.title}}
                                 </router-link>
                                <p style="line-height:18px;text-align:left;color: #daa75c;">{{item.sku_cn}}</p>
                            </div>
                            
                        </dd>
                        <dd class="b14">
                            <span class="ca_jg">¥ {{item.pro.price}}</span>
                        </dd>
                        <dd class="b14">
                            <el-input-number v-model="item.number" :min="1" @change="handleChange(item,item.number)" ></el-input-number>
                        </dd>
                        <dd class="b14">
                            <span class="ca_jg c_xjr">¥ {{$fnc.toFixedZ(item.pro.sum_price)}}</span>
                        </dd>
                        <dd class="b9">
                            <span @click="delPro(index,item.id)" :data-id="item.id" class="ca_del" style="cursor:pointer">删除</span>
                        </dd>
                    </dl>
                </div>
            </div>
            <!--循环结束-->
            <div class="over pd20">
                <div class="left pt15" style="font-size:16px;">
                    共计:<b class="rmb"> ¥</b>
                    <b class="f18 red" id="count2" style="font-size:22px;">{{$fnc.toFixedZ(totalMoney)}}</b>
                </div>
                <span class="ga_buy right hand" @click="onSubmit">
                    <i class="iconfont icon-gouwuchekong" ></i> 去结算<em id="car_nums">({{checkedCount}})</em>
                </span>
                <a href="/" class="ga_car right">继续购物</a>
            </div>
            <div class="jfooter" id="jfooter">
                <div class="w">
                    <input type="checkbox" v-model="checkAll" style="margin-right:10px;">全选({{checkedCount}})
                    <span class="c_jie hand" @click="onSubmit">
                        <i class="iconfont icon-gouwuchekong" ></i> 去结算<em id="car_nums">({{checkedCount}})</em>
                    </span>
                    <div class="fc_rb">
                        <p  style="font-size:22px;line-height:36px;">共计:<b class="rmb"> ¥</b><b class="f18" id="count" style="font-size:22px;">{{$fnc.toFixedZ(totalMoney)}}</b></p>
                    </div>
                    <div class="clear"></div>
                </div>
            </div>   
        </div>
        <public-nothing v-else></public-nothing>
    </div>
</template>

<script>
import Public_nothing from "@/components/car/nothing_car"
export default {
    components:{
        'public-nothing': Public_nothing,
    },
    data() {
        return {
            list:[],
            picture:"",
            number:1,
            checked:[],
            totalPrice:[],
            id_str: "",
            togg: true,
            index: 0,
            ii:"",
            // 判断全选是否为真
            all:""
        };
    },
    computed:{
        //总价
        totalMoney:function(item,index){
            let sum = 0;
            // for(let i=0;i<this.totalPrice.length;i++){
            //     sum += this.totalPrice[i];
            // };
            for(let i=0;i<this.list.length;i++){
                //判断全选是否为真和勾选的数量和长度是否一致
                if(this.all == true && this.checkedCount == this.list.length){
                    sum += this.list[i].number * this.list[i].pro.price;
                }else{
                    if(this.list[i].checked == true){
                        sum == 0;
                        sum += this.list[i].number * this.list[i].pro.price;
                    }
                }
                //单价
                this.list[i].pro.sum_price = this.list[i].number * this.list[i].pro.price;
            };
            return sum;
        },
        //全选
        checkAll: {
            get: function() {
                //判断勾选的个数和数组的长度是否相等
                return this.checkedCount == this.list.length;
            },
            set: function(value){
                var _this = this;
                // console.log(value)
                if (value) {
                    // 把value 赋值给all
                    // this.checkedCount;
                    this.all = value;
                    this.totalPrice = [];
                    this.checked = this.list.map(function(item) {
                        item.checked = true;
                        let total = item.number*item.pro.price;
                        _this.totalPrice.push(total);
                        return item.id
                    })
                }else{
                    //取消全选
                    // this.checkedCount;
                    this.checked = [];
                    this.totalPrice=[];
                    this.list.forEach(function(item,index){
                        item.checked = false;
                    });
                }
            }
        }, 
        // 勾选的数量
        checkedCount:{
            get: function() {
                return this.checked.length;
            }
        }
    },
    created(){
        this.cartList();
        this.getCartNum();
        // this.$store.dispatch("getCardNum");
        // this.getAddress(JSON.parse(window.localStorage.getItem("user")).id);
    },
    methods: {
        //获取地址列表
        // getAddress(id){
        //     var params = {};
        //     params.id = id || "";
        //     this.$api.getUser.getAddress(params).then(res=>{
        //         this.list = [];
        //         var arr = res.result;
        //         if(arr != ""){
        //             arr.forEach((item,index)=>{
        //                 this.list.push(item);
        //                 var address = JSON.stringify(this.list[0]);//将获取到的数据转换为json数据
        //                 window.localStorage.setItem('address', address);
        //             })
        //         }else{
        //             var address = JSON.stringify('暂无收货地址可使用');
        //             window.localStorage.setItem('address', address);
        //         }
        //     })
        // },
       handleChange(item,value) {  //加减
            var params = {};
            params.id = item.id;
            params.number = value;
            params.uid = JSON.parse(window.localStorage.getItem("user")).id;
            this.$api.getShop.updateCardNumber(params).then(res => {
                if (res.code == 200) {
                    
                } else {
                    value = value - 1;
                }
                //window.location.reload();//刷新页面
                // this.cartList();
            })
        },
        cartList(){
            var cart_params = {};
            cart_params.uid = JSON.parse(window.localStorage.getItem("user")).id;
            this.$api.getShop.getCartList(cart_params).then(res => {
                if (res.code == 200) {
                    this.list = [];
                    var arr = res.result[0].data;
                    // arr.forEach((item,i) => {
                    //     this.list.push(item);
                    // });
                    //判断删除时是否有数据
                    if(arr != undefined){
                        //循环显示
                        arr.forEach((item,i) => {
                            this.list.push(item);
                        });
                    }else{
                        // console.log("请先选择商品")
                    }
                    
                }
            });
        },
        getCartNum(){
            var params = {};
            params.uid = JSON.parse(window.localStorage.getItem("user")).id || "";
            this.$api.getShop.get_carnum(params).then(res => {
                if (res.code == 200) {
                }
            });
        },
        getCardLineNu (skuTitle) {
            var card = this.cardList;
            var cards = card.cardlist;
            var sid = this.$route.query.id || 0;
            if (
                card.cardID != sid &&
                cards[sid + "cardItem"] == undefined &&
                cards[sid + "cardItem"][0] == undefined &&
                cards[sid + "cardItem"][0].data.length == 0
            ) {
                return;
            } else {
                var str = skuTitle.join(" ").trim();
                var arr = cards[sid + "cardItem"][0].data;
                for (var i in arr) {
                if (arr[i].sku_cn.trim() == str) {
                    this.number = arr[i].number;
                    this.checkSkuTitle = str;
                    break;
                } else {
                    this.checkSkuTitle = str;
                    this.number = 1;
                }
                }
            }
        },
        currClick:function(item,index){
            var _this = this;
            if(typeof item.checked == 'undefined'){
                this.$set(item,'checked',true);
                let total = item.number*item.pro.price;
                this.totalPrice.push(total);
            }else{
                item.checked = !item.checked;
                if(item.checked){
                    this.totalPrice = [];
                    this.list.forEach(function(item,index){
                        if(item.checked){
                            let total = item.number*item.pro.price;
                            _this.totalPrice.push(total);
                        }
                    });
                }else{
                    this.totalPrice = [];
                    this.list.forEach(function(item,index){
                        if(item.checked){
                            let total = item.number*item.pro.price;
                            _this.totalPrice.push(total);
                        }
                    });
                }
            }
        },
        onSubmit () {
            // var params = {};
            // var that = this;
            // params.id_str = this.checked;
            if (this.checkedCount <= 0) {
                this.$alert('未选择商品', '提示', {
                    confirmButtonText: '确定',
                });
                return;
            }
            if (this.togg) {
                this.ii = [];
                this.checked.forEach((item,index)=>{
                    this.ii += '@' + item;
                })
                var params = {};
                params.id_str = this.ii.slice(1);
                params.address_id = JSON.parse(window.localStorage.getItem("address")).id || "";
                params.uid = JSON.parse(window.localStorage.getItem("user")).id || "";
                console.log(params)
                this.$api.getShop.addOrder(params).then(res => {
                    if(res.code == 200){
                        window.location.reload();
                        console.log(res)
                        var orderInfo = JSON.stringify(res);//将获取到的数据转换为json数据
                        window.localStorage.setItem('orderInfo', orderInfo);
                    }
                })
                
                this.$router.push({path:'/buy_car_jiesuan', query:{showVideo:1}});
            }
        },
        //删除
        delPro(index,id){
            var params = {};
            params.id_str = id || "";
            params.uid = JSON.parse(window.localStorage.getItem("user")).id || "";
            this.$confirm(`是否删除？`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$api.getShop.delCard(params).then(res=>{
                    if(res.code == 200){
                        this.$alert('删除成功', '提示', {
                            confirmButtonText: '确定',
                        }).then(()=>{
                            window.location.reload();
                            // this.list.splice(index,1);
                        });
                    }
                })
            });
        }
    }
}
</script>

<style scoped>
@import url('../../assets/css/car.css');
.el-input-number {
    position: relative;
    display: inline-block;
    width: 130px;
    line-height: 38px;
}
tr td{
        width:200px;
        background: #eee;
        padding:10px 0;
    }
</style>


// WEBPACK FOOTER //
// src/components/car/buy_car.vue